import { useResourceDetailsQuery } from '@/queries/resources.queries';
import { useTranslation } from 'react-i18next';

interface IArgs {
	id: string;
}

export default function useEditAvailabilityModal(args: IArgs) {
	const { t } = useTranslation();
	const query = useResourceDetailsQuery({ id: args.id });

	return {
		query,
		t,
	};
}
